// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3eR0t","content":"styles_content__3EMGQ","flexButton":"styles_flexButton__2iNLI","formikErrors":"styles_formikErrors__1iy-e"};